import { NavLink } from 'react-router';
import { cn } from '@/lib/utils';
import { navItems } from './navItems';

export function SideNav() {
  return (
    <aside className="hidden w-56 shrink-0 border-r border-(--color-border) bg-(--color-surface) md:flex md:flex-col">
      <div className="flex h-16 items-center px-5 text-lg font-semibold tracking-tight">
        <span className="font-display">Organiza.AI</span>
      </div>
      <nav aria-label="Navegação principal" className="flex flex-1 flex-col gap-1 px-3 py-3">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-(--color-surface-elevated) text-(--color-accent)'
                  : 'text-(--color-fg-muted) hover:bg-(--color-surface-elevated) hover:text-(--color-fg)',
              )
            }
          >
            <Icon className="h-4 w-4" aria-hidden />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
